import { useMemo } from 'react';

import { skipToken } from '@reduxjs/toolkit/query';

import { useFetchInStoreSinksQuery } from '~/api/local-api/sinks-api/sinksService';
import { shouldFetchFn } from '~/api/utils';
import { ApplianceSource } from '~/core/models';
import { emptyArray, makeSinksSelector } from '~/core/utils';
import { useAppSelector } from '~/redux/hooks';
import { selectSelectedMaterial } from '~/redux/slices/material';
import { selectInStoreSinksUrl } from '~/redux/slices/sink';
import { selectZipcode } from '~/redux/slices/zipcode';

export const useFetchInStoreSinks = () => {
  const inStoreSinksUrl = useAppSelector(selectInStoreSinksUrl);
  const selectInStoreSinksTransformed = useMemo(() => makeSinksSelector(), []);
  const zipcode = useAppSelector(selectZipcode);
  const selectedMaterial = useAppSelector(selectSelectedMaterial);

  const shouldFetch = shouldFetchFn({
    args: [zipcode, selectedMaterial, inStoreSinksUrl],
  });

  const {
    inStoreSinks,
    isFetching: isFetchingInStoreSinks,
    isError: isErrorInStoreSinks,
  } = useFetchInStoreSinksQuery(
    shouldFetch ? { url: inStoreSinksUrl } : skipToken,
    {
      selectFromResult: ({ data, ...rest }) => ({
        inStoreSinks: selectInStoreSinksTransformed(
          data ?? emptyArray,
          ApplianceSource.IN_STORE,
          undefined,
          true
        ),
        ...rest,
      }),
    }
  );

  return {
    inStoreSinks,
    isFetchingInStoreSinks,
    isErrorInStoreSinks,
  };
};
